export default {
    apiKey: "AIzaSyBMyqRy94STVTVaaS0JzUWs0mrKrzQChwQ",
    authDomain: "calendoro.firebaseapp.com",
    projectId: "calendoro",
    storageBucket: "calendoro.appspot.com",
    messagingSenderId: "641531390674",
    appId: "1:641531390674:web:b4eadaabff95ce1ecedb0b",
    measurementId: "G-TD837XQ2FN"
};